import { load } from "../events/load.js";

const sceleton = {
	element: 'Not loaded yet',
	container: "Not loaded yet",
	init: function(){
		this.container = document.querySelector("#apartamentsList");
		this.container?.classList.remove('load')
		this.element = this.container?.querySelector(".element");
		return this;
	},
	spawn: function(count = 3){
		for (let i = 0; i < count; i++) {
			this.container?.appendChild(this.clone());
		}
		return this;
	},
	clone: function(){
		return this.element.cloneNode(true);
	},
	remove: function(){
		this.container?.querySelectorAll(".element:has(.sceleton-element)")?.forEach((el)=>{
			el.remove();
		})
		return this;
	},
	callbacks: [

	],
	afterInit: function(){
		this.callbacks.forEach((cb)=>{
			cb();
		})
		return this;
	}
}



load(()=>{
	sceleton.init().remove().afterInit()
});
export {sceleton}